import { render, staticRenderFns } from "./CommitteesCards.vue?vue&type=template&id=6dde96a9&scoped=true&"
import script from "./CommitteesCards.vue?vue&type=script&lang=js&"
export * from "./CommitteesCards.vue?vue&type=script&lang=js&"
import style0 from "./CommitteesCards.vue?vue&type=style&index=0&id=6dde96a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dde96a9",
  null
  
)

export default component.exports